import { IOrderDto } from "../interface/IOrderDto"
import { UserInfoDto } from "./UserInfoDto"
import { OrderAddressDto } from "./OrderAddressDto"
import { OrderPaymentDto } from "./OrderPaymentDto"
import { orderMerch } from "./IOrderMerchDto"
import {
  DeliveryType,
  OrderStatus,
  PaymentType,
  PaymentStatus,
} from "../enum/OrderEnum"
export const OrderDto: IOrderDto = {
  id: "",
  userId: "",
  merchId: "",
  merchName: "",
  merchLogo: "",
  addressid: "",
  userExpectedPickupDate: "",
  systemCalculatedReadyForPickupTime: "",
  userExpectedDeliveryTimeRangeStart: "",
  merchantConfirmedDeliveryTimeRangeStart: "",
  merchantConfirmedDeliveryTimeRangeEnd: "",
  merchantRefundTotal: 0,
  merchantRefundTotalExcludeTax: 0,
  merchantRefundTotalTax: 0,
  orderTotalTaxReceivedByMerchant: 0,
  deliveryType: DeliveryType.Both,
  orderStatus: OrderStatus.WaitingForAcceptance,
  paymentType: PaymentType.Online,
  paymentStatus: PaymentStatus.Voided,
  remark: "",
  deleted: false,
  serialNumber: "",
  invoiceNumber: "",
  orderItems: [],
  merch: orderMerch,
  orderDate: "",
  user: UserInfoDto,
  address: OrderAddressDto,
  readyAt: "",
  completedAt: "",
  rejectedAt: "",
  turnedProcessingAt: "",
  orderTotal: 0,
  orderTotalExcludeTax: 0,
  orderTotalTax: 0,
  refundTotal: 0,
  orderTotalPaidByCustomer: 0,
  complainTotal: 0,
  orderPayment: OrderPaymentDto,
  orderCancellationPenaltyPercentage: 0,
  paymentSubmittedDate: "",
  canCancel: false,
  canRate: false,
  cancelRejectedItems: [],
  hasPendingApprovalRefund: false,
  orderTotalReceivedByMerchant: 0,
  orderParkingLotPickupFieldValues: [],
  pickupSubtype: 0,
  customerArrivedDate: "",
  trackingUrl: "",
  pointsPerDollar: 0,
  pointsRefunded: 0,
  pointsUsed: 0,
  originalOrderTotalReceivedByMerchant: 0,
  originalOrderTotalTaxReceivedByMerchant: 0,
}
